/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import { create } from "zustand";
import { persist } from "zustand/middleware";

export type LengthPreference = "short" | "medium" | "long" | "default";

interface LengthState {
  selectedLength: LengthPreference;
  setSelectedLength: (length: LengthPreference) => void;
}

export const useLengthStore = create<LengthState>()(
  persist(
    (set) => ({
      selectedLength: "default",
      setSelectedLength: (length: LengthPreference) =>
        set({ selectedLength: length }),
    }),
    {
      name: "length-storage", // unique name for localStorage key
    },
  ),
);
